import Flex from 'UIKit/Box/Flex'
import IconButton from 'UIKit/Button/IconButton'
import useModal from 'hooks/useModal'
import React from 'react'
import { Trans } from 'react-i18next'
import styled, { css } from 'styled-components'
import { Icons } from 'svgs'
import ProviderModal, { ProviderModalProps } from '.'

const ButtonSelectProvider: React.FC<ProviderModalProps> = ({ selectedProviders, onProvidersChanged }) => {
  const [onPressent] = useModal(ProviderModal)

  const handleOpenModal = () => onPressent({ selectedProviders, onProvidersChanged })

  return (
    <StyledWrapper $active={selectedProviders.length > 0} onClick={handleOpenModal} amount={selectedProviders.length}>
      <Flex mr={['', '', '12px']} height="fit-content">
        <Icons.ProviderFilterIcon />
      </Flex>
      <Trans>Provider</Trans>
    </StyledWrapper>
  )
}

const StyledWrapper = styled(IconButton)<{ $active: boolean; amount: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 40px;
  border: 1px solid ${({ theme }) => theme.colors.strokeAlt1};
  color: ${({ theme }) => theme.colors.textSubtle};

  ${({ $active }) =>
    $active &&
    css`
      border-color: ${({ theme }) => theme.colors.text};
      color: ${({ theme }) => theme.colors.text};
      svg path {
        fill: ${({ theme }) => theme.colors.text}; !important;
      }
    `}

  ${({ amount }) =>
    amount > 0 &&
    css`
      &::after {
        content: '${amount}';
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: ${({ theme }) => theme.colors.text};
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 12px;

        position: absolute;
        top: -4px;
        right: -4px;
      }
    `}

  width: 60px;
  height: 44px;
  font-size: 0;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 125px;
    height: 44px;
    font-size: 14px;
  }
`

export default ButtonSelectProvider
